import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtgFooterModule } from './atg-footer/atg-footer.module';
import { ConfigModule } from '@spartacus/core';
import { AtgTranslationFactory } from './assets/translations/atg-translations.factory';
import { AtgCheckoutDeliveryModeModule } from './atg-checkout-delivery-mode/atg-checkout-delivery-mode.module';
import { AtgOderConfirmationModule } from './atg-oder-confirmation/atg-oder-confirmation.module';
import { CardModule } from '@spartacus/storefront';
import { AtgNavigationModule } from './atg-navigation/atg-navigation.module';
import { AtgDraftOrderDetailsModule } from './atg-draft-order-details/atg-draft-order-details.module';
import { AtgCheckoutReviewSubmitModule } from './atg-checkout-review-submit/atg-checkout-review-submit.module';
import { AtgDraftOrderItemsModule } from './atg-draft-order-items/atg-draft-order-items.module';
import { KnBrConsentManagementModule } from './kn-br-consent-management/kn-br-consent-management.module';
import { AtgAddToCartModule } from './atg-add-to-cart/atg-add-to-cart.module';
import { AtgUserRegisterModule } from './atg-user-register/atg-user-register.module';
import { AtgPriceListModule } from './atg-price-list/atg-price-list.module';
import { AtgPriceListReportModule } from './atg-price-list-report/atg-price-list-report.module';
import { AtgUserManagementModule } from './atg-user-management/atg-user-management.module';
import { AtgHomepageMyOrdersModule } from './atg-homepage-my-orders/atg-homepage-my-orders.module';
import { AtgHomepageImageCarouselModule } from './atg-homepage-image-carousel/atg-homepage-image-carousel.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CardModule,
    AtgFooterModule,
    AtgCheckoutDeliveryModeModule,
    AtgOderConfirmationModule,
    AtgNavigationModule,
    AtgDraftOrderDetailsModule,
    AtgCheckoutReviewSubmitModule,
    AtgDraftOrderItemsModule,
    KnBrConsentManagementModule,
    AtgAddToCartModule,
    AtgUserRegisterModule,
    AtgPriceListModule,
    AtgPriceListReportModule,
    AtgUserManagementModule,
    AtgHomepageMyOrdersModule,
    AtgHomepageImageCarouselModule,
    ConfigModule.withConfigFactory(AtgTranslationFactory),
  ],
})
export class AtgFeaturesModuleModule { }
